import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Notice } from '../../../shared/components/ui/notice/notice';
import { PasswordRecoveryService } from '../../services/password-recovery.service';

/**
 * "Forgot password?" — a link under a team-password form that asks the server
 * to e-mail the app's contact address a one-time sign-in link. Always shown:
 * when the server reported recovery as unavailable on startup, the click
 * explains that an administrator has to reset the password instead.
 */
@Component({
  selector: 'andor-forgot-password',
  standalone: true,
  imports: [TranslatePipe, Notice],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPassword {
  readonly recovery = inject(PasswordRecoveryService);
  // A short wait (the 60 s cooldown) is shown in seconds — "1 minutes" reads
  // wrong; longer waits (the 15-minute budget) in whole minutes.
  readonly retrySeconds = computed(() => this.recovery.cooldown.remaining('recoveryRequest'));
  readonly retryMinutes = computed(() => Math.max(1, Math.ceil(this.retrySeconds() / 60)));
  readonly retryInMinutes = computed(() => this.retrySeconds() >= 120);

  request(): void {
    void this.recovery.requestRecovery();
  }
}
